export function extractPositionsLayout(payload: any, nestedKey = 'layout'): { positions: Record<string, unknown> } | null {
  const candidate = payload?.[nestedKey] && typeof payload[nestedKey] === 'object' ? payload[nestedKey] : payload;
  if (!candidate || typeof candidate !== 'object' || Array.isArray(candidate)) return null;
  const positions =
    candidate.positions && typeof candidate.positions === 'object' && !Array.isArray(candidate.positions)
      ? candidate.positions
      : {};
  return { positions };
}
